import messages_en from './en';
import messages_fi from './fi';

const Locale: any = {
    en: messages_en,
    fi: messages_fi,
};

export default Locale;
